module.exports = __webpack_public_path__ + "static/media/damahaOnly.1c527580.ogg";